import { preferenceActions } from '../store';
import { PreferenceKey, StoredPreference } from '../types';

export interface MigrationConfig {
  localKey: string;
  prefId: PreferenceKey;
  transform?: (value: any) => any;
  featureFlagName?: string;
  stopMigration?: boolean;
}

export const migrateLocalStorage = async (configs: MigrationConfig[], bulkMutation: any): Promise<void> => {
  const migratedData: Record<string, StoredPreference> = {};
  const userSettingsMap: Record<string, string> = {};

  const keysToRemove: string[] = [];

  for (const config of configs) {
    const localValue = localStorage.getItem(config.localKey);
    if (localValue && !config.stopMigration) {
      try {
        let parsedValue = JSON.parse(localValue);

        if (config.transform) {
          parsedValue = config.transform(parsedValue);
        }

        migratedData[config.prefId] = {
          id: config.prefId,
          value: parsedValue,
          updatedAt: new Date().toISOString(),
        };

        userSettingsMap[config.prefId] = JSON.stringify(parsedValue);

        keysToRemove.push(config.localKey);
      } catch (error) {
        console.warn(`Failed to migrate localStorage key: ${config.localKey}`, error);
      }
    }
  }

  if (Object.keys(migratedData).length > 0) {
    preferenceActions.setPreferences(migratedData);
    bulkMutation.mutate(userSettingsMap);
    keysToRemove.forEach((key) => localStorage.removeItem(key));

    console.log(`Migrated ${Object.keys(migratedData).length} preferences from localStorage`);
  }
};
